import React from 'react';
/**
 * @function LayoutContainer 
 * @param {React.Component} children - React components that's being wrapped by the page layout container.
 * @returns {React.Component}
 * @example
 * <LayoutContainer>
 *  <LeftColumnContainer>
 *    <h1>Left content</h1>
 *  </LeftColumnContainer>
 *  <RightColumnContainer>
 *    <h1>Right content</h1>
 *  </RightColumnContainer>
 * </LayoutContainer>
 */
export default function LayoutContainer(props) {
  const className = props.className ?? "";

  return (
    <div className={ `column-container flex-container justify-center flex-horizontal layout-container ${ className }` }>
      {props.children}
    </div>
  );
}